export default __webpack_public_path__ + "static/media/couple@2x.2ff59248.png";